///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { Fragment } from "react";
import { useSelector } from "react-redux";

import EmailIcon from "../icons/EmailIcon";
import ExcelIcon from "../icons/ExcelIcon";
import PdfIcon from "../icons/PdfIcon";
import PictureIcon from "../icons/PictureIcon";
import WordIcon from "../icons/WordIcon";
import { fileTypes } from "../../helpers/types";

export const FileIcon = ({
  mimeType,
  height = "27px",
  width = "24px",
  className,
  fileExtension,
  ...rest
}) => {
  const { supportedFiles } = useSelector(state => state.app).supportedFiles;
  const checkFileType = filetype =>
    supportedFiles.some(
      s =>
        s.fileType === filetype &&
        (s.mimeType === mimeType || s.fileExtension === fileExtension)
    );

  return (
    <Fragment>
      {checkFileType(fileTypes.email) && (
        <EmailIcon
          className={"align-top " + className}
          height={height}
          width={width}
          fill="#61BEE2"
          {...rest}
        />
      )}
      {checkFileType(fileTypes.excel) && (
        <ExcelIcon
          className={"align-top " + className}
          height={height}
          width={width}
          fill="#007732"
          {...rest}
        />
      )}
      {checkFileType(fileTypes.pdf) && (
        <PdfIcon
          className={"align-top " + className}
          height={height}
          width={width}
          fill="#FF241E"
          {...rest}
        />
      )}
      {checkFileType(fileTypes.picture) && (
        <PictureIcon
          className={"align-top " + className}
          height={height}
          width={width}
          fill="#B00020"
          {...rest}
        />
      )}
      {checkFileType(fileTypes.word) && (
        <WordIcon
          className={"align-top " + className}
          height={height}
          width={width}
          fill="#1D409D"
          {...rest}
        />
      )}
    </Fragment>
  );
};

export default FileIcon;
